import React, { useEffect, useState } from "react";
import "./AccountView.css";
import TauriImage from "../../TauriImage/TauriImage";
import appURL from "../../../appURL.json";
import { transformPlanningAccount } from "../PlanningFactoryData/PlanningFactoryData";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import { getAll, syncDataToLocal } from "../../../localDB";
import AccountDetailsModal from "../../OpalCoverageLayout/AccountDetailsModal/AccountDetailsModal";
import Button from "react-bootstrap/Button";

const statusAccount = {
  0: "#C2C0C0",
  1: "#FD9B09",
  2: "#079D33",
};

const AccountsView = ({ id }) => {
  const [search, setSearch] = useState("");
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAccID, setSelectedAccID] = useState(null);
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const fetchPlanningAccounts = async (search) => {
    setLoading(true);
    try {
      const c_id = localStorage.getItem("c_id");
      const token = localStorage.getItem("token");
      const devId = localStorage.getItem("devId");

      const storedPermission = localStorage.getItem("permission");
      const permission = JSON.parse(atob(storedPermission));

      const response = await fetch(
        `${appURL.API_Worksheet}/accounts/${Number(permission?.coverage?.employee_id)}/${Number(c_id)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-ETR-Device-ID": devId,
          },
        },
      );

      if (!response.ok) {
        console.log("data:", response);
        return;
      }

      const data = await response.json();
      let tfPlnAccount = await transformPlanningAccount(data.accounts);

      if (search) {
        const lower = search.toLowerCase();
        tfPlnAccount = tfPlnAccount.filter(
          (item) =>
            item.Name?.toLowerCase().includes(lower) ||
            item.Code?.toLowerCase().includes(lower),
        );
      }
      setItemList(tfPlnAccount);

      await syncDataToLocal("PlanningAccounts", tfPlnAccount);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchOfflinePlanningAccounts = async (search) => {
    setLoading(true);
    try {
      let tfPlnAccount = await getAll("PlanningAccounts");

      if (search) {
        const lower = search.toLowerCase();
        tfPlnAccount = tfPlnAccount.filter(
          (item) =>
            item.Name?.toLowerCase().includes(lower) ||
            item.Code?.toLowerCase().includes(lower),
        );
      }
      setItemList(tfPlnAccount);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (searchTerm) => {
    const isOnline = JSON.parse(localStorage.getItem("isOnline"));
    const hasInternet = navigator.onLine;

    if (isOnline && hasInternet) {
      await fetchPlanningAccounts(searchTerm);
    } else {
      await fetchOfflinePlanningAccounts(searchTerm);
    }
  };

  const handleExportAccountList = async () => {
    setIsExporting(true);
    try {
      const token = localStorage.getItem("token");
      const devId = localStorage.getItem("devId");

      const response = await fetch(`${appURL.API_ExportAccountList}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-ETR-Device-ID": devId,
        },
      });

      if (!response.ok) {
        console.error("Failed to export accounts");
        return;
      }

      const blob = await response.blob();

      const today = new Date();
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const dd = String(today.getDate()).padStart(2, "0");
      const yyyy = today.getFullYear();

      const formattedDate = `${mm}${dd}${yyyy}`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Accounts_${formattedDate}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    fetchData(search);
  }, [id, search]);

  const handleRowClick = (accID) => {
    setSelectedAccID(accID);
    setShowAccountDetails(true);
  };

  return (
    <div className="opal-account-view w-100">
      <div className="filter-section d-flex flex-row align-items-center justify-content-between mb-4 gap-2">
        <div>
          <Button
            onClick={() => handleExportAccountList()}
            className="btn export-btn d-flex align-items-center justify-content-center gap-2"
            disabled={isExporting}
          >
            {isExporting ? (
              <TauriLoader2
                width="1rem"
                height="1rem"
                borderwidth="0.1rem"
                color="#fff"
              />
            ) : (
              <TauriImage
                localImage={"/Images/download.svg"}
                alt="icon"
                color={"#fff"}
              />
            )}
            Accounts
          </Button>
        </div>
        <div className="search-section d-flex align-items-center p-2">
          <TauriImage
            localImage={"/Images/symbols--search.svg"}
            alt="icon"
            color={"#7FA6D3"}
          />
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Type to Search"
              autoComplete="new-password"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="account-list-table">
        {loading ? (
          <TauriLoader2
            width="2.5rem"
            height="2.5rem"
            borderwidth="0.35rem"
            color="#1D5D9B"
          />
        ) : (
          <table className="table w-100 border-collapse">
            <thead className="account-list-table-header">
              <tr>
                <th style={{ width: "2rem" }} className="text-center col-check">
                  <TauriImage
                    localImage={"/Images/carbon--settings.svg"}
                    alt="icon"
                    color={"#000"}
                  />
                </th>
                <th style={{ width: "10rem" }}>REFERENCE CODE</th>
                <th>ACCOUNT NAME</th>
                <th style={{ width: "12rem" }}>LAST VISITED CYCLE</th>
                <th style={{ width: "16rem" }}>SYSTEM NOTES</th>
              </tr>
            </thead>
            <tbody className="account-list-table-body">
              {itemList.map((row, idx) => (
                <tr
                  key={row.ID}
                  className={idx % 2 === 0 ? "" : "even"}
                  onClick={() => handleRowClick(row.ID)}
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    <TauriImage
                      localImage={"/Images/circle-check.svg"}
                      alt="icon"
                      color={statusAccount[row.Status]}
                    />
                  </td>
                  <td>{row.Code}</td>
                  <td>{row.Name}</td>
                  <td>{row.LastVisited}</td>
                  <td>{row.ReasonID}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <AccountDetailsModal
        show={showAccountDetails}
        onHide={() => setShowAccountDetails(false)}
        accID={selectedAccID}
      />
    </div>
  );
};

export default AccountsView;
